import { memo } from 'react';

export default memo(() => {
  return null;
});
